import { useAccount } from './use-account'
import { useCart, createCart } from '@corratech/pylot-cart-manager'
import { useRouter } from 'next/router'
import { getIsSignedIn } from './utils/getIsSignedIn'
import { clearCheckoutStorage } from '@lib/utils/checkoutStorage'

type UseLogoutReturn = { logout: () => Promise<void> }

export const useLogout = (): UseLogoutReturn => {
    const router = useRouter()
    const { locale } = router
    const { mutate: updateAccount } = useAccount()
    const { mutate: fetchNewCart } = useCart()

    return {
        logout: async () => {
            const isSignedIn = getIsSignedIn()
            if (isSignedIn) {
                window.localStorage.removeItem('pylot_token')
                window.localStorage.removeItem('cart_id')
                // El estado de checkout es de la persona que estaba comprando:
                // su direccion de invitado, la tienda de retiro que eligio y
                // quien pasaba a retirar. Al cerrar sesion se va con el carro.
                clearCheckoutStorage()
                // Delete customer data from SWR cache without triggering an unnecessary GQL query
                updateAccount({ data: { customer: undefined } }, false)
                await createCart({ locale })
                fetchNewCart()
                window.dispatchEvent(new CustomEvent('pylot:refresh-content'))
            }
        }
    }
}
